<div class="preview-item-container" [class.isLocked]="isLocked == true">
  <div class="download-icon" (click)="download($event)" *ngIf="canDownload">
    <img src="/assets/download-icon.svg" alt="" />
  </div>

  <div
    class="gallery-set-head-icon"
    (click)="setAsGalleryHead($event)"
    *ngIf="canSetAsGalleryHead"
  >
    <img src="/assets/gallery-set-head.svg" alt="" />
  </div>

  <div class="card__locked" *ngIf="isLocked">
    <div class="card__locked_bg"></div>
    <div class="card__locked-by">
      <span>Edited by: </span>
      <span class="locked-name">
        {{ lockedBy }}
      </span>
    </div>
    <img src="/assets/lock.png" alt="" class="lock-icon" />
  </div>

  <div *ngIf="!isVideo" class="preview-item-container-image-container">
    <div class="loading-container"></div>
    <div class="image-wrapper" #imageWrapper>
      <div class="image-inner-wrapper" #imageInnerWrapper>
        <img
          *ngIf="shouldLoadBlur && !imageLoaded && !isImageError"
          [src]="imageLoadingPreviewUrl"
          (error)="erroredImage($event)"
          (load)="loadedPreviewImage($event)"
        />
        <img
          #mainImage
          *ngIf="!isImageError"
          [src]="imagePreviewUrl"
          (error)="erroredImage($event)"
          (load)="loadedImage($event)"
        />
        <ng-container
          *ngIf="imagePreviewUrl
              && importItem
              && importItem.faces
              && importItem.faces.length > 0
              && showFaceAI"
        >
          <ng-container *ngFor="let face of importItem.faces">
            <div
              class="face-detection-box"
              [class.recognized]="face.person != undefined"
              *ngIf="face.x && face.y"
              [ngStyle]="{
                'top': (face.y_percent || 0) + '%',
                'left': (face.x_percent || 0) + '%',
                'height': (face.height_percent || 0) + '%',
                'width': (face.width_percent || 0) + '%'
              }"
              >
              <!-- Enhanced name display with proper name hierarchy -->
              <div class="face-name" [class.unrecognized]="!face.person">
                {{
                  face.person
                    ? (face.person.name || face.person.title || face.person.value || face.person)
                    : 'Unknown'
                }}
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <div *ngIf="isVideo" class="preview-item-container-video-container">
    <div class="loading-container"></div>
    <div class="image-wrapper">
      <div class="image-inner-wrapper">
        <img
          *ngIf="shouldLoadBlur && !imageLoaded && !isImageError"
          [src]="imageLoadingPreviewUrl"
          (error)="erroredImage($event)"
          (load)="loadedPreviewImage($event)"
        />
        <img
          *ngIf="!isImageError"
          [src]="imagePreviewUrl"
          (error)="erroredImage($event)"
          (load)="loadedImage($event)"
        />
      </div>
    </div>
    <div class="video-button-holder"></div>
  </div>

  <!-- Ažurirani AI status s uvjetnim stilovima -->
  <div class="preview-item-container-ai-status"
       *ngIf="aiStatus && isAiProcessing"
       [class.processing]="isProcessingStatus(aiStatus)"
       [class.complete]="isCompleteStatus(aiStatus)"
       [class.failed]="isFailedStatus(aiStatus)"
       [class.glimmer-text]="isProcessingStatus(aiStatus)">
    <img src="assets/ai.svg"
         class="processing-icon"/>
    <span class="status-text">
      {{ aiStatus }}
    </span>
  </div>

  <div class="preview-item-container-error" *ngIf="isError">
    Data missing
    <img
      class="preview-item-container-error-icon"
      src="assets/import-error.svg"
    />
  </div>

  <div class="preview-item-container-selection">
    <div></div>
  </div>

</div>
